import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "dashboard-card pt-2 px-3"
}
const _hoisted_3 = { class: "team-info-drawer__header fixed-header" }
const _hoisted_4 = {
  class: "title ellipsis mr-2",
  style: {"max-width":"55vw"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"60px"} }, null, -1)
const _hoisted_6 = { style: {"color":"#999999"} }
const _hoisted_7 = {
  key: 0,
  class: "font-weight-medium"
}
const _hoisted_8 = { class: "text-color-secondary" }
const _hoisted_9 = {
  key: 1,
  class: "font-weight-medium"
}
const _hoisted_10 = ["onMouseenter"]

import VTable from '@/components/VTable.vue'
import VUserInfo from '@/components/VUserInfo.vue';
import { useProgramsStore } from '@/stores/programs';
import { useUiStore } from '@/stores/ui';
import dayjs from 'dayjs';
import { computed, ref, watch } from 'vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'StudentMarks',
  setup(__props) {

const router = useRouter()
const programsStore = useProgramsStore()

const program = computed(() => {
  return programsStore.programs.find(item => item.id === router.currentRoute.value.params.programId)
})
const currentTeamId = ref<string>("all")
watch(() => program.value, (program) => {
  if (!program) return
  programsStore.requestTransfers(program)
  programsStore.requestAnalitics(program)
  currentTeamId.value = "all"
}, { immediate: true })

const teams = computed(() => {
  if (!program.value?.teams) return []
  return [ { id: "all", name: "Все команды" }, ...program.value?.teams ]
})

const students = computed(() => {
  let arr = program.value?.students
  if (!arr) return []
  if (currentTeamId.value && currentTeamId.value !== "all") {
    arr = arr.filter(team => team.teamId === currentTeamId.value)
  }
  return arr
})

const teamsMap = computed(() => {
  const map = new Map()
  if (!program.value) return map
  for (let team of program.value.teams) {
    map.set(team.id, team)
  }
  return map
})

const _tm = (i: number) => "tm"+(i+1)

const columns = computed(() => ({
  name: { title: "Студент", width: 250 },
  team: { title: "Команда", width: 200 },
  average: { title: "Средняя оценка", width: 112 },
  ...Object.fromEntries(groupedReports.value.map((item, index) => [
    _tm(index), { 
      title: "TM"+(index+1), 
      class: "report-cell", 
      thClass: "report-cell", 
      width: 60,
      tooltip: dayjs(item[0].date).startOf("week").format("DD MMM") + " - " + dayjs(item[0].date).endOf("week").format("DD MMM")
    },
  ])),
  empty: { title: "" }
}))

const marks = computed(() => {
  if (!program.value || !program.value.transfers) return []
  return students.value.map(student => {
    const transfers = program.value!.transfers?.filter(transfer => transfer.studentId === student.id)!
    let transferIndex = 0
    const reports = groupedReports.value.map(group => {
      for (let report of group) {
        if (!transfers[transferIndex]) break
        while (transfers[transferIndex] && transfers[transferIndex].date < report.date) {
          transferIndex++
          continue
        }
        if (transfers[transferIndex] && report.teamId === transfers[transferIndex].teamId) {
          return report
        }
      }
      if (transfers[transferIndex]) return null

      return group.find(report => report.teamId === student.teamId) || null
    })
    const count = reports.reduce((sum, report) => sum + ((!report || report.executionScore === 1)? 0: 1), 0) || 1
    const average = (reports.reduce((sum, report) => {
      if (!report || report.executionScore === 1) return sum
      return sum + report.executionScore
    }, 0) / count)
    return [ average, ...reports ]
  })
})

const weekConstant = 1000 * 60 * 60 * 24 * 7
const weekStart = dayjs().day(1).startOf("day").unix() * 1000
const groupedReports = computed(() => {
  const reports = program.value?.analitics?.reports
  if (!reports || reports.length === 0 || !program.value.transfers) return []

  const weeks: any[][] = []
  let currentWeek: number | null = null
  let weeksArr: number[] = []
  for (let report of reports) {
    let week = Math.floor((Date.parse(report.date) - weekStart) / weekConstant)
    if (currentWeek === null || week > currentWeek) {
      weeks.push([])
      weeksArr.push(week)
      weeks[weeks.length-1].unshift(report)
      currentWeek = week
    } else if (week < currentWeek){
      const index = weeksArr.indexOf(week)
      if (index >= 0) {
        weeks[index].unshift(report)
      }
    }else if (week === currentWeek){
      weeks[weeks.length-1].unshift(report)
    }
    
  }
  return weeks
})

const getColor = (report: any) => {
  if (!report) return "none"
  let val = report.executionScore
  if (val >= 5) return "#CDFED5"
  if (val >= 4) return "#FEF3CD"
  if (val >= 3) return "#FECDCD"
  return "none"
}

const uiStore = useUiStore()
const openTooptip = (e: MouseEvent, report: any) => {
  if (!program.value || !report) return
  const team = program.value.teams.find(item => item.id === report.teamId)
  if (!team) return
  uiStore.openTooptip(e, team.name)
}

const getMark = (mark: number) => {
  if (mark < 3.6) return "0"
  if (mark < 3.9) return "50"
  if (mark < 4.3) return "70"
  if (mark < 4.7) return "90"
  if (mark < 5) return "100"
  return "110"
  // return ((mark-3) / 2 * 100).toFixed()
}

const getLastTeams = (student: any) => {
  const transfers = program.value!.transfers?.filter(transfer => transfer.studentId === student.id)!

  if (!transfers) return []

  return transfers.map(item => ({
    team: item.teamId && teamsMap.value.get(item.teamId),
    date: item.date
  }))
}


return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(program)?.students)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, "Оценки студентов программы " + _toDisplayString(_unref(program).name), 1),
            _createVNode(_component_v_select, {
              modelValue: currentTeamId.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentTeamId).value = $event)),
              items: _unref(teams) || [],
              class: "v-select-min ml-auto mt-n1",
              variant: "outlined",
              label: "Команда",
              "item-value": "id",
              "item-title": "name"
            }, null, 8, ["modelValue", "items"])
          ]),
          _hoisted_5,
          (_openBlock(), _createBlock(VTable, {
            key: _unref(program).id,
            columns: _unref(columns),
            data: _unref(students)
          }, _createSlots({
            name: _withCtx(({ item }) => [
              _createVNode(VUserInfo, { user: item }, null, 8, ["user"])
            ]),
            team: _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString((item.teamId && _unref(teamsMap).get(item.teamId)?.name) || "Нет команды") + " ", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getLastTeams(item), (team) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(team.team?.name), 1))
              }), 256))
            ]),
            average: _withCtx(({ index }) => [
              (_unref(groupedReports).length > 0 && _unref(marks)[index][0])
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_unref(marks)[index][0].toFixed(1)) + " ", 1),
                    _createElementVNode("span", _hoisted_8, "(" + _toDisplayString(getMark(_unref(marks)[index][0])) + "%)", 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, "-"))
            ]),
            _: 2
          }, [
            _renderList(_unref(groupedReports), (group, i) => {
              return {
                name: _tm(i),
                fn: _withCtx(({ item, index }) => [
                  _createElementVNode("div", {
                    class: "analitics-cell font-weight-medium",
                    style: _normalizeStyle({ backgroundColor: getColor(_unref(marks)[index][i+1]) }),
                    onMouseenter: ($event: any) => (openTooptip($event, _unref(marks)[index][i+1]))
                  }, _toDisplayString(_unref(marks)[index][i+1]?.executionScore || "-"), 45, _hoisted_10)
                ])
              }
            })
          ]), 1032, ["columns", "data"]))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})